import { Loader2 } from 'lucide-react';
import { Button, OutboundLink } from '@higgins/ui';
import { formatDateTime } from '../lib/dates';
import type { MarkedUpStatus } from '../lib/marked-up-plan';
import { MARKED_UP_WORDING, type CopyWording } from '../lib/plan-copy-wording';
import { ErrorMessage } from './message';

interface Props {
  status: MarkedUpStatus;
  webUrl: string | null;
  savedOn: string | null;
  saving: boolean;
  error: string | null;
  ready: boolean;
  online: boolean;
  save: () => Promise<void>;
  wording?: CopyWording;
}

/** A copy of the plan on SharePoint (marked up, or access): whether it shows today's pins or lines, a link to it, and the button that saves it. */
export function MarkedUpStatusLine({ status, webUrl, savedOn, saving, error, ready, online, save, wording = MARKED_UP_WORDING }: Props) {
  return (
    <div className="space-y-2">
      <div className={`flex flex-wrap items-center gap-x-3 gap-y-2 text-xs ${status === 'outOfDate' ? 'text-amber-800' : 'text-slate-500'}`} role="status">
        <span>
          {wording.status[status]}
          {status !== 'none' && savedOn ? ` (${formatDateTime(savedOn)}).` : ''}
        </span>
        {webUrl && (
          <OutboundLink openIn="edge" href={webUrl} className="text-primary underline">
            Open {wording.name}
          </OutboundLink>
        )}
        {status !== 'current' && (
          <Button variant="outline" className="ml-auto h-11" disabled={saving || !ready || !online} onClick={() => void save()}>
            {saving ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden /> : null}
            {saving ? 'Saving…' : wording.button[status]}
          </Button>
        )}
      </div>
      {status !== 'current' && !online && <p className="text-xs text-slate-500">Saving {wording.name} needs signal.</p>}
      {error && <ErrorMessage>{wording.name.replace(/^t/, 'T')} couldn’t be saved: {error}</ErrorMessage>}
    </div>
  );
}
